import React, { useCallback, useContext, useEffect, useState } from "react";
import SearchIcon from "@mui/icons-material/Search";
import {
  CircularProgress,
  Tooltip,
  InputAdornment,
  TextField,
  Button,
  TableContainer,
  Table,
  TableHead,
  TableBody,
  Paper,
  TablePagination,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Box,
} from "@mui/material";
import { styled } from "@mui/material/styles";
import TableCell, { tableCellClasses } from "@mui/material/TableCell";
import TableRow from "@mui/material/TableRow";
import { ContextSession } from "../../../services/ContextSession";
import { appColors } from "../../../services/theme.service";
import ManageSearchIcon from "@mui/icons-material/ManageSearch";
import IconButton from "@mui/material/IconButton";
import Popover from "@mui/material/Popover";
import CryptoJS from "crypto-js";
import VisibilityIcon from "@mui/icons-material/Visibility";
import { useNavigate } from "react-router-dom";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: appColors.brand.primary,
    color: appColors.neutral.white,
    fontSize: 16,
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 14,
    borderRight: "none", // Elimina la línea vertical entre columnas
    borderLeft: "none", // Elimina la línea vertical entre columnas
  },
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
  "&:nth-of-type(odd)": {
    backgroundColor: theme.palette.action.hover,
  },
  // hide last border
  "&:last-child td, &:last-child th": {
    border: 0,
  },
  "&:hover": {
    // Agrega estilo al pasar el cursor sobre la fila
    backgroundColor: "#C1C1C1", // Cambia el color de fondo al pasar el cursor
  },
}));

function ListaSolConstanciasSubSanandoCC() {
  let sessi = useContext(ContextSession);
  const [page, setPage] = useState(0);
  const [loading, setLoading] = useState(true);
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const [searchDNI, setSearchDNI] = useState("");
  const handleSearchDNIChange = (event) => setSearchDNI(event.target.value);
  const navigate = useNavigate();
  const [rows, setRows] = useState([]);
  const tiposConstancia = {
    1: "HISTORIAL DE COTIZACIONES",
    2: "RAZONADA",
    3: "SALDOS PROYECTADOS",
    4: "NO TENER PRÉSTAMO ACTIVO",
    5: "TRÁMITE EMBAJADA",
  };

  tiposConstancia[6] = "PAGO DE PRESTACIONES";
  tiposConstancia[8] = "PAGO DE PRESTACIONES";

  // const dominio = "http://172.20.7.10:8082";
  //const dominio = "https://be.injupemp.gob.hn:8443";
  //const dominio = "http://127.0.0.1:8000"; -- Error identificado previo al 23 junio 2026 - jsauceda
  const dominio = "https://be.injupemp.gob.hn:8443"; //cambio realizado 23 junio 2026 - jsauceda


  // NUEVO: estados para dialog y fila seleccionada
  const [openDialog, setOpenDialog] = useState(false);
  const [selectedRow] = useState(null);
  const [patchLoading, setPatchLoading] = useState(false);
  const [openSuccessDialog, setOpenSuccessDialog] = useState(false);

  const [anchorEl, setAnchorEl] = useState(null);
  const [filterType, setFilterType] = useState("");

  const handleFilterClick = (event, type) => {
    setAnchorEl(event.currentTarget);
    setFilterType(type);
  };

  const handleFilterClose = () => {
    setAnchorEl(null);
    setFilterType("");
  };

  const open = Boolean(anchorEl);
  const id = open ? "simple-popover" : undefined;

  // 1. Mueve fetchData fuera de useEffect
  const fetchData = useCallback(async () => {
    setLoading(true);
    try {
      const secretKey =
        "django-insecure-8mo+j636(t*_cj&s&&3$7@*vwsk#yyl0u5fbv-v*^-)e!y&k#8";
      const queryString = `Subsanando=11005250527SUB`;
      const signature = CryptoJS.HmacSHA256(queryString, secretKey).toString(
        CryptoJS.enc.Hex
      );

      const response = await fetch(`${dominio}/api/ConstanciaPag/Subsanando/`, {
        // const response = await fetch(`http://172.20.7.10:8082/api/ConstanciaPag/Subsanando/`, {
        method: "GET",
        headers: {
          "X-Signature": signature,
          "Content-Type": "application/json",
        },
      });

      if (!response.ok) throw new Error("Error al obtener los datos");
      const data = await response.json();
      setRows(data);
    } catch (error) {
      setRows([]);
    }
    setLoading(false);
  }, []);

  useEffect(() => {
    fetchData();
  }, [fetchData]);

  const handleChangePage = (event, newPage) => setPage(newPage);
  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const filteredRows = rows.filter((row) => {
    const meetsInitialCriteria =
      row.subsanando === true && [6, 8].includes(row.fk_id_constancia);

    if (searchDNI.trim() !== "") {
      // Asegúrate de que row.dniSolicitante existe y coincide con la búsqueda
      const dniMatch =
        row.DNI_usuario &&
        row.DNI_usuario.toString()
          .toLowerCase()
          .includes(searchDNI.toLowerCase());

      return meetsInitialCriteria && dniMatch;
    } // <- Aquí cerraste el if pero faltaba el return para cuando NO hay búsqueda

    return meetsInitialCriteria; // <- Este return debe estar fuera del if
  });

  // --- Función para abrir el dialog ---
  // 2. PATCH y dialog de éxito
  const handleAccept = async () => {
    if (!selectedRow) return;
    setPatchLoading(true);
    try {
      const secretKey =
        "django-insecure-8mo+j636(t*_cj&s&&3$7@*vwsk#yyl0u5fbv-v*^-)e!y&k#8";
      const idSolicitud = selectedRow.id_solicitud_constancia;
      const idUser = sessi.sessionData.id;
      const queryString = `IdSolicitud=${idSolicitud}`;
      const signature = CryptoJS.HmacSHA256(queryString, secretKey).toString(
        CryptoJS.enc.Hex
      );
      const url = `${dominio}/api/ConstanciaPag/ConstanciaSG/Aprobar/?IdSolicitud=${idSolicitud}&IdUserSG=${idUser}`;
      //const url = `https://be.injupemp.gob.hn:8443/api/ConstanciaPag/ConstanciaSG/Aprobar/?IdSolicitud=${idSolicitud}&IdUserSG=${idUser}`;

      const response = await fetch(url, {
        method: "PATCH",
        headers: {
          "X-Signature": signature,
          "Content-Type": "application/json",
        },
      });

      if (!response.ok) throw new Error("Error al aprobar la solicitud");
      // CIERRA el dialog y muestra el de éxito
      setOpenDialog(false);
      setOpenSuccessDialog(true);
    } catch (error) {
      alert("Ocurrió un error al aprobar la solicitud.");
    }
    setPatchLoading(false);
  };

  // 3. Cuando el usuario acepta el dialog de éxito, cierra el dialog y actualiza la tabla
  const handleSuccessDialogClose = () => {
    setOpenSuccessDialog(false);
    fetchData();
  };

  const handleClick = (id) => {
    sessi.setVariable("IDsolConstanciaSG", id);
    navigate("/PortalDelParticipante/VerSolicitudConstanciaCC");
  };

  return (
    <div className="container" style={{ marginTop: 10 }}>
      <>
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            marginTop: 10,
          }}
        >
          <h2>
            <b>Lista de Solicitudes de Constancias Subsanando Cartera y Cobro</b>
          </h2>
        </div>

        {/*-- <Box sx={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: 2,
                    flexWrap: 'wrap',
                    mb: 2,
                    mt: 1,
                    justifyContent: 'center' // <--- Cambia aquí
                }}>
                    <FormControl size="small" sx={{ minWidth: 170 }}>
                        <FormHelperText>Filtrar por Estado</FormHelperText>
                        <Select
                            value={statusFilter}
                            onChange={(e) => {
                                setStatusFilter(e.target.value);
                                setPage(0);
                            }}
                            displayEmpty
                            fullWidth
                        >
                            <MenuItem value="2">Pendiente de Aprobar</MenuItem>
                            <MenuItem value="4">Emitida</MenuItem>
                        </Select>
                    </FormControl>
                </Box> */}

        <div className="row" style={{ marginTop: "20px" }}>
          <TableContainer component={Paper}>
            <Table>
              <TableHead>
                <StyledTableRow>
                  <StyledTableCell>#</StyledTableCell>
                  <StyledTableCell>
                    <div style={{ display: "flex", alignItems: "center" }}>
                      <strong>DNI Solicitante</strong>
                      <Tooltip title="Buscar por DNI" arrow>
                        <IconButton
                          onClick={(event) =>
                            handleFilterClick(event, "searchDNI")
                          }
                          color={searchDNI ? "primary" : "default"}
                        >
                          <ManageSearchIcon
                            style={{
                              color: searchDNI ? "#1976d2" : "white",
                            }}
                          />
                        </IconButton>
                      </Tooltip>
                    </div>
                  </StyledTableCell>
                  <StyledTableCell>Solicitante</StyledTableCell>
                  <StyledTableCell>Nº Recibo</StyledTableCell>
                  <StyledTableCell>Tipo Constancia</StyledTableCell>
                  <StyledTableCell>Monto</StyledTableCell>
                  <StyledTableCell>Fecha Pagado</StyledTableCell>
                  <StyledTableCell>Detalle Solicitud</StyledTableCell>
                  <StyledTableCell>Observación Subsanación</StyledTableCell>
                  <StyledTableCell style={{ textAlign: "center" }}>
                    Acciones
                  </StyledTableCell>
                </StyledTableRow>
              </TableHead>

              <Popover
                id={id}
                open={open}
                anchorEl={anchorEl}
                onClose={handleFilterClose}
                anchorOrigin={{
                  vertical: "bottom",
                  horizontal: "center",
                }}
                transformOrigin={{
                  vertical: "top",
                  horizontal: "center",
                }}
                sx={{
                  p: 2,
                  "& .MuiTextField-root": {
                    m: 1,
                    width: "250px",
                  },
                }}
              >
                {filterType === "searchDNI" && (
                  <Box sx={{ p: 2 }}>
                    <TextField
                      placeholder="Buscar por DNI"
                      aria-label="Buscar por DNI"
                      value={searchDNI}
                      onChange={handleSearchDNIChange}
                      autoFocus
                      InputProps={{
                        startAdornment: (
                          <InputAdornment position="start">
                            <SearchIcon />
                          </InputAdornment>
                        ),
                      }}
                    />
                    <Box
                      sx={{
                        mt: 1,
                        display: "flex",
                        justifyContent: "flex-end",
                      }}
                    >
                      <Button
                        size="small"
                        onClick={() => setSearchDNI("")}
                        disabled={!searchDNI}
                      >
                        Limpiar
                      </Button>
                    </Box>
                  </Box>
                )}
              </Popover>

              <TableBody>
                {loading ? (
                  <StyledTableRow>
                    <StyledTableCell colSpan={11} align="center">
                      <CircularProgress size={24} />
                    </StyledTableCell>
                  </StyledTableRow>
                ) : filteredRows && filteredRows.length > 0 ? (
                  filteredRows
                    .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                    .map((row, idx) => (
                      <StyledTableRow key={row.id_solicitud_constancia}>
                        <StyledTableCell>
                          {page * rowsPerPage + idx + 1}
                        </StyledTableCell>
                        <StyledTableCell>{row.DNI_usuario}</StyledTableCell>
                        <StyledTableCell>
                          {row.NombreCompleto_usuario}
                        </StyledTableCell>
                        <StyledTableCell>{row.numero_recibo}</StyledTableCell>
                        <StyledTableCell>
                          {tiposConstancia[row.fk_id_constancia] ||
                            "DESCONOCIDO"}
                        </StyledTableCell>
                        <StyledTableCell>L.{row.monto}</StyledTableCell>

                        <StyledTableCell>
                          {row.fecha_pagada
                            ? row.fecha_pagada.split("T")[0] +
                              " " +
                              row.fecha_pagada.split("T")[1].substring(0, 8)
                            : "-"}
                        </StyledTableCell>
                        <StyledTableCell>
                          {row.detalle_solicitud}
                        </StyledTableCell>
                        <StyledTableCell>
                          {row.Observacion_subsanar}
                        </StyledTableCell>
                        <StyledTableCell>
                          <Box display="flex" justifyContent="center">
                            <Tooltip
                              title="Ver Solicitud"
                              arrow
                              placement="left-start"
                            >
                              <IconButton
                                onClick={() =>
                                  handleClick(row.id_solicitud_constancia)
                                }
                              >
                                <VisibilityIcon
                                  sx={{ color: "green", fontSize: 30 }}
                                />
                              </IconButton>
                            </Tooltip>
                          </Box>
                        </StyledTableCell>
                      </StyledTableRow>
                    ))
                ) : (
                  <StyledTableRow>
                    <StyledTableCell colSpan={11} align="center">
                      No hay datos.
                    </StyledTableCell>
                  </StyledTableRow>
                )}
              </TableBody>
            </Table>
          </TableContainer>
          <TablePagination
            rowsPerPageOptions={[5, 10, 25]}
            component="div"
            count={filteredRows.length}
            rowsPerPage={rowsPerPage}
            page={page}
            onPageChange={handleChangePage}
            labelRowsPerPage={"Filas por página"}
            onRowsPerPageChange={handleChangeRowsPerPage}
          />
        </div>

        <Dialog open={openDialog} onClose={() => setOpenDialog(false)}>
          <DialogTitle textAlign={"center"}>Confirmar Aceptación</DialogTitle>
          <DialogContent>
            <DialogContentText>
              ¿Está seguro de aceptar la Constancia{" "}
              <b>
                {selectedRow && tiposConstancia[selectedRow.fk_id_constancia]}{" "}
              </b>
              con N° Recibo <b>{selectedRow && selectedRow.numero_recibo}</b> y
              enviarla a la Unidad de Operaciones?
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button
              onClick={() => setOpenDialog(false)}
              color="error"
              disabled={patchLoading}
            >
              No
            </Button>
            <Button
              onClick={handleAccept}
              color="primary"
              variant="contained"
              disabled={patchLoading}
            >
              {patchLoading ? <CircularProgress size={18} /> : "Sí"}
            </Button>
          </DialogActions>
        </Dialog>

        {/* DIALOG DE ÉXITO */}
        <Dialog open={openSuccessDialog} onClose={handleSuccessDialogClose}>
          <DialogTitle>
            <Box display="flex" alignItems="center" justifyContent="center">
              <span style={{ fontWeight: 500 }}>Solicitud Enviada</span>
              <CheckCircleIcon style={{ color: "green", marginLeft: 10 }} />
            </Box>
          </DialogTitle>
          <DialogContent>
            <DialogContentText textAlign={"justify"}>
              La solicitud de constancia se aceptó con éxito y fue enviada a la
              Unidad de Operaciones.
            </DialogContentText>
          </DialogContent>
          <DialogActions sx={{ justifyContent: "center" }}>
            <Button
              onClick={handleSuccessDialogClose}
              color="primary"
              variant="contained"
              sx={{ mx: "auto", minWidth: 120 }}
            >
              Aceptar
            </Button>
          </DialogActions>
        </Dialog>
      </>
    </div>
  );
}

export default ListaSolConstanciasSubSanandoCC;
